import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=665cc2d5&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=665cc2d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665cc2d5",
  null
  
)

export default component.exports